import Tooltip from '~/shared/components/Tooltip';
import Typography from '~/shared/components/Typography';

interface ErrorTooltipProps {
  tooltipId: string;
  message?: string;
}

export default function ErrorTooltip({ tooltipId, message }: ErrorTooltipProps) {
  return (
    <Tooltip
      positionStrategy="fixed"
      place="top"
      id={tooltipId}
      style={{ zIndex: 9999, maxWidth: 320 }}
      render={() => (
        <div className="flex flex-col gap-[2px] px3 py2 max-w-[316px] ">
          <Typography color="text-white" variant="caption" className="text-wrap">
            {message}
          </Typography>
        </div>
      )}
    />
  );
}
